"use client";
import React, { useState, useEffect } from "react";
import helpers from "../../_helpers/common";
import useAxios from "../../hooks/useAxios";

interface Props {
  show: boolean;
  onClose: () => void;
  onSuccess: () => void; // 🔁 refresh list
  editData?: any;
}

export default function CouponModal({ show, onClose, onSuccess, editData }: Props) {
  const axiosInstance = useAxios();

  const defaultForm = {
    code: "",
    type: "percentage",
    value: 0,
    min_cart_value: 0,
    max_discount: 0,
    usage_limit: 0,
    per_user_limit: 1,
    start_date: "",
    end_date: "",
    is_active: true,
  };

  const [form, setForm] = useState(defaultForm);
  const [errors, setErrors] = useState<any>({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editData) {
		setForm({
		  ...defaultForm,
		  ...editData,
		  start_date: formatDate(editData.start_date),
		  end_date: formatDate(editData.end_date),
		});
	}
	if (!editData && show) {
      setForm((p) => ({ ...p, code: helpers.generateCouponCode() }));
    }
    //else setForm(defaultForm);
  }, [editData, show]);
  
  const formatDate = (dateString: string) => {
	  if (!dateString) return "";
	  return new Date(dateString).toISOString().split("T")[0];
	};

  const update = (k: string, v: any) => {
    setForm((p) => ({ ...p, [k]: v }));
    setErrors((p: any) => ({ ...p, [k]: "" }));
  };

  const validate = () => {
    const e: any = {};
    if (!form.code.trim()) e.code = "Code is required";
    if (!form.value || form.value <= 0) e.value = "Discount is required";
    if (!form.start_date) e.start_date = "Start date is required";
    if (!form.end_date) e.end_date = "End date is required";
    if (new Date(form.start_date) > new Date(form.end_date))
      e.end_date = "End date must be later";

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      setLoading(true);

      const payload = {
        ...form,
        code: form.code.toUpperCase().trim(),
        _id: editData?._id,
      };

      const res: any = await axiosInstance({
        url: "/coupons/create-update",
        method: "POST",
        data: payload,
      });

      if (!res.error) {
        onClose();
        onSuccess(); // 🔁 refresh list
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;
  console.log('editData', editData);
  return (
    <>
    <div
        className="modal fade show"
        tabIndex={-1}
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable animate__animated animate__fadeInDown">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">{editData ? "Edit Coupon" : "Add Coupon"}</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            <div className="row g-3">

              <div className="col-md-6">
                <label className="form-label">Coupon Code *</label>
                <input
                  className={`form-control ${errors.code ? "is-invalid" : ""}`}
                  value={form.code}
                  onChange={(e) => update("code", e.target.value)}
                />
                <div className="invalid-feedback">{errors.code}</div>
              </div>

              <div className="col-md-6">
                <label className="form-label">Type</label>
                <select
                  className="form-select"
                  value={form.type}
                  onChange={(e) => update("type", e.target.value)}
                >
                  <option value="percentage">Percentage %</option>
                  <option value="fixed">Fixed Amount</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">Discount *</label>
                <input
                  type="number"
                  className={`form-control ${errors.value ? "is-invalid" : ""}`}
                  value={form.value}
                  onChange={(e) => update("value", Number(e.target.value))}
                />
                <div className="invalid-feedback">{errors.value}</div>
              </div>

              {form.type === "percentage" && (
                <div className="col-md-6">
                  <label className="form-label">Max Discount</label>
                  <input
                    type="number"
                    className="form-control"
                    value={form.max_discount}
                    onChange={(e) => update("max_discount", Number(e.target.value))}
                  />
                </div>
              )}

              <div className="col-md-6">
                <label className="form-label">Min Cart Value</label>
                <input
                  type="number"
                  className="form-control"
                  value={form.min_cart_value}
                  onChange={(e) => update("min_cart_value", Number(e.target.value))}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Usage Limit</label>
                <input
                  type="number"
                  className="form-control"
                  value={form.usage_limit}
                  onChange={(e) => update("usage_limit", Number(e.target.value))}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Start Date *</label>
                <input
                  type="date"
                  className={`form-control ${errors.start_date ? "is-invalid" : ""}`}
                  value={form.start_date}
                  onChange={(e) => update("start_date", e.target.value)}
                />
                <div className="invalid-feedback">{errors.start_date}</div>
              </div>

              <div className="col-md-6">
                <label className="form-label">End Date *</label>
                <input
                  type="date"
                  className={`form-control ${errors.end_date ? "is-invalid" : ""}`}
                  value={form.end_date}
                  onChange={(e) => update("end_date", e.target.value)}
                />
                <div className="invalid-feedback">{errors.end_date}</div>
              </div>

              <div className="col-12 form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={form.is_active}
                  onChange={(e) => update("is_active", e.target.checked)}
                />
                <label className="form-check-label">Active</label>
              </div>

            </div>
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
              {loading ? "Saving..." : "Save Coupon"}
            </button>
          </div>

        </div>
      </div>
    </div>
	<div className="modal-backdrop fade show" />
	</>
  );
}
